import Api from "./Api";

export default {
    getAllOceanInsightList(payload) {
        let AllOceanInsightsList = Api().post(
            "Api_Tracking/getOceanInsightsContainerTrack.php",
            payload
        );
        return AllOceanInsightsList;
    },
    getAllOceanWebhookList(payload) {
        let webhookList = Api().post(
            "Api_Tracking/getOFWebHook.php",
            payload
        );
        return webhookList;
    },
};



// WEBPACK FOOTER //
// ./src/services/OceanInsightsSubscriptionService.js